module.exports = __webpack_public_path__ + "img/paypal.d0caad61.png";